module.exports = __webpack_public_path__ + "img/icon_home_xc.91032ad0.png";